import { takeLatest, call, put } from 'redux-saga/effects';
import { postPatientInsuranceSuccess, postPatientInsuranceFailure, putPatientInsuranceSuccess, putPatientInsuranceFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
function* postPatientInsuranceRequest(action) {
    try {
const response = yield call(apiPost, 'api/post-patient-insurance', action.payload);
        yield put(postPatientInsuranceSuccess(response));
    } catch (error) {
        yield put(postPatientInsuranceFailure(error?.response?.message || error));
    }
}


function* putPatientInsuranceRequest(action) {
    try {
const response = yield call(apiPut, `api/edit-patient-insurance/${action.payload._id}`, action.payload);
        yield put(putPatientInsuranceSuccess(response));
    } catch (error) {
        yield put(putPatientInsuranceFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('patientInsurance/postPatientInsuranceRequest', postPatientInsuranceRequest);
    yield takeLatest('patientInsurance/putPatientInsuranceRequest', putPatientInsuranceRequest);
}

export default saga;